/**
 * Core-owned client-tool registry. Provider-neutral: maps a tool name to a host
 * handler. Names are unique — re-registering a live name throws; replace via
 * unregister-then-register. The returned unregister is idempotent and identity-guarded.
 * Backed by a Map, so inherited names (toString/constructor/__proto__) never resolve.
 */
import type { ClientTool, ClientTools, ClientToolRegistry } from "./types.js";

export function createClientToolRegistry(seed?: ClientTools): ClientToolRegistry {
  const map = new Map<string, ClientTool>();
  if (seed) for (const [name, handler] of Object.entries(seed)) map.set(name, handler);

  return {
    register(name, handler) {
      if (map.has(name)) {
        throw new Error(
          `[voice-agent] client tool "${name}" is already registered; ` +
            "unregister it before re-registering.",
        );
      }
      map.set(name, handler);
      let live = true;
      return () => {
        if (live && map.get(name) === handler) map.delete(name);
        live = false;
      };
    },
    get(name) {
      return map.get(name);
    },
    list() {
      return [...map.keys()];
    },
  };
}
